// extracted by mini-css-extract-plugin
module.exports = {"container":"v0","bottomGradient":"v1","image":"v2","brandLogoFrame":"v3","logoImage":"v4","logoImageFrame":"v5"};